import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const equipmentApiKeyStore = {
  createEquipment: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_EQUIPMENT`],
    route: `/Equipment`,
    action: 'POST',
  }),
  updateEquipment: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_EQUIPMENT`],
    route: `/Equipment`,
    action: 'PUT',
  }),
  deleteEquipment: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_EQUIPMENT`, id],
    route: `/Equipment/${id}`,
    action: 'DELETE',
  }),
  getEquipments: (): QueryKeyConfig => ({
    queryKey: [`GET_EQUIPMENTS`],
    route: `/Equipment`,
  }),

  //Equipment Calibration
  createEquipmentCalibration: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_EQUIPMENT_CALIBRATION`],
    route: `/EquipmentCalibration`,
    action: 'POST',
  }),
  updateEquipmentCalibration: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_EQUIPMENT_CALIBRATION`],
    route: `/EquipmentCalibration`,
    action: 'PUT',
  }),
  deleteEquipmentCalibration: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_EQUIPMENT_CALIBRATION`, id],
    route: `/EquipmentCalibration/${id}`,
    action: 'DELETE',
  }),
  getEquipmentCalibrations: (): QueryKeyConfig => ({
    queryKey: [`GET_EQUIPMENT_CALIBRATIONS`],
    route: `/EquipmentCalibration`,
  }),
  getEquipmentCalibrationById: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_EQUIPMENT_CALIBRATINO_BY_ID`, id],
    route: `/EquipmentCalibration/${id}`,
  }),
  getEquipmentCalibrationServices: (): QueryKeyConfig => ({
    queryKey: [`GET_EQUIPMENT_CALIBRATION_SERVICES`],
    route: `/EquipmentCalibration/EquipmentServices`,
  }),
};
